import { AppError } from "../../app-store-error.types";

// Feature states
import { CurrencyState, initialCurrencyState } from "./currency/currency.state";
import { DeliveryTermState, initialDeliveryTermState } from "./delivery-term/delivery-term.state";
import { PaymentTermState, initialPaymentTermState } from "./payment-term/payment-term.state";
import { InterestRateState, initialInterestRateState } from "./interest-rate/interest-rate.state";
import { FinancingCompanyState, initialFinancingCompanyState } from "./financing-company/financing-company.state";
import { SalesCreditRoleState, initialSalesCreditRoleState } from "./sales-credit-role/sales-credit-role.state";
import { EcoLabelState, initialEcoLabelState } from "./eco-label/eco-label.state";
import { UnspscState, initialUnspscState } from "./unspsc/unspsc.state";
import { BrandState, initialBrandState } from "./brand/brand.state";
import { CategoryState, initialCategoryState } from "./category/category.state";
import { LocationState, initialLocationState } from "./location/location.state";
import { ContractTypeState, initialContractTypeState } from "./contract-type/contract-type.state";
import { CatalogTypeState, initialCatalogTypeState } from "./catalog-type/catalog-type.state";
import { SubscriptionConceptState, initialSubscriptionConceptState } from "./subscription-concept/subscription-concept.state";
import { SalesPersonState, initialSalesPersonState } from "./sales-person/sales-person.state";
import { SalesSupportPersonState, initialSalesSupportPersonState } from "./sales-support-person/sales-support-person.state";
import { CountryState, initialCountryState } from "./country/country.state";
import { CreditCheckState, initialCreditCheckState } from "./credit-check/credit-check.state";
import { CustomerTypeState, initialCustomerTypeState } from "./customer-type/customer-type.state";

// **************************************************************************
// DATA STATE
// **************************************************************************
export interface DataState {
    // Feature states
    currency: CurrencyState;
    deliveryTerm: DeliveryTermState;
    paymentTerm: PaymentTermState;
    interestRate: InterestRateState;
    financingCompany: FinancingCompanyState;
    salesCreditRole: SalesCreditRoleState;
    ecoLabel: EcoLabelState;
    unspsc: UnspscState;
    brand: BrandState;
    category: CategoryState;
    location: LocationState;
    contractType: ContractTypeState;
    catalogType: CatalogTypeState;
    subscriptionConcept: SubscriptionConceptState;
    salesPerson: SalesPersonState;
    salesSupportPerson: SalesSupportPersonState;
    country: CountryState;
    creditCheck: CreditCheckState;
    customerType: CustomerTypeState;
    // Cross-cutting
    error: AppError | null;
    loading: boolean;
}

export const initialDataState: DataState = {
    // Feature states
    currency: initialCurrencyState,
    deliveryTerm: initialDeliveryTermState,
    paymentTerm: initialPaymentTermState,
    interestRate: initialInterestRateState,
    financingCompany: initialFinancingCompanyState,
    salesCreditRole: initialSalesCreditRoleState,
    ecoLabel: initialEcoLabelState,
    unspsc: initialUnspscState,
    brand: initialBrandState,
    category: initialCategoryState,
    location: initialLocationState,
    contractType: initialContractTypeState,
    catalogType: initialCatalogTypeState,
    subscriptionConcept: initialSubscriptionConceptState,
    salesPerson: initialSalesPersonState,
    salesSupportPerson: initialSalesSupportPersonState,
    country: initialCountryState,
    creditCheck: initialCreditCheckState,
    customerType: initialCustomerTypeState,
    // Cross-cutting
    error: null,
    loading: false,
};
